const init = {
    name: { value: '', valid: true },
    source: { value: [], valid: true },
    policyIds: { value: {}, valid: true },
};

export default init;
